import type React from "react"
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa"
import "./PlaceSelector.css"

export type PlaceData = {
  name: string
  address: string
  lat: number
  lng: number
  campingSiteId?: string | number // Optional ID for linking to backend existing site
}

type PlaceSelectorProps = {
  place: PlaceData | null
  onOpenSearch: () => void
  onRemove: () => void
}

export const PlaceSelector: React.FC<PlaceSelectorProps> = ({
  place,
  onOpenSearch,
  onRemove,
}) => {
  if (!place) {
    return (
      <div className="place-selector-container">
        <button className="place-add-btn" onClick={onOpenSearch} type="button">
          <FaMapMarkerAlt color="#999" />
          <span>장소 추가</span>
        </button>
      </div>
    )
  }

  return (
    <div className="place-selector-container">
      <div className="place-info">
        <div className="place-details">
          <span className="place-name">{place.name}</span>
          <span className="place-address">{place.address}</span>
        </div>
        <button className="place-remove-btn" onClick={onRemove} type="button">
          <FaTimes />
        </button>
      </div>
    </div>
  )
}
